import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { Message } from '@swf/sports/components';

import { TXTWCL_This_event_has_now_finishedX } from './EventFinishedMessage.messages.json';

const EventFinishedMessage = () => (
  <Message message={<Translation {...TXTWCL_This_event_has_now_finishedX} />} />
);

export default EventFinishedMessage;
